export var fileContent = {
    message: {
        withHeader: false,
        columns: [{ key: "phone", label: "PhoneNumber" }, { key: "message", label: "Message" }],
        rows: {
            default: [
                { phone: "", message: "Msg1111" },
                { phone: "", message: "Message 2345" }
            ],
            91: [
                { phone: "", message: "Msg1111" },
                { phone: "", message: "Message 2345" }
            ],
            233: [
                { phone: "", message: "Msg1111" },
                { phone: "", message: "Message 2345" }
            ],
        }
    },
    costsheet: {
        withHeader: true,
        columns: [
            { key: "country", label: "Country" },
            { key: "country_code", label: "Country Code" },
            { key: "iso2", label: "IS02" },
            { key: "network", label: "Network" },
            { key: "cost_price", label: "Cost Price" },
            { key: "selling_price", label: "Selling Price" },
        ],
        rows: {
            default: [
                { "country": "Ascension Island", "country_code": "247", "iso2": "AC", "network": "MTN Ascension Island Network", "cost_price": 0.095, "selling_price": 0.095 },
                { "country": "Morocco", "country_code": "212", "iso2": "MA", "network": "Morocco Network1", "cost_price": 0.128, "selling_price": 0.128 },
                { "country": "Morocco", "country_code": "212", "iso2": "MA", "network": "Morocco Network2", "cost_price": 0.092, "selling_price": 0.092 },
                { "country": "United Arab Emirates", "country_code": "971", "iso2": "AE", "network": "Roshan", "cost_price": 0.092, "selling_price": 0.155 },
                { "country": "United Arab Emirates", "country_code": "971", "iso2": "AE", "network": "Roshan2", "cost_price": 0.092, "selling_price": 0.155 }
            ]
        }
    },
    DNDNumbers: {
        withHeader: false,
        columns: [
            { key: "phone", label: "PhoneNumber" },
            { key: "category", label: "Category" },
        ],
        rows: {
            default: [
                { phone: "", category: "Promotional" },
                { phone: "", category: "Transactional" },
                { phone: "", category: "OTP" },
                { phone: "", category: "Promotional,Transactional" },
                { phone: "", category: "Promotional,OTP" },
                { phone: "", category: "Transactional,OTP" },
                { phone: "", category: "Promotional,Transactional,OTP" }
            ]
        }
    },
    blacklistNumbers: {
        withHeader: false,
        columns: [{ key: "phone", label: "PhoneNumber" }],
        rows: {
            default: [
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", }
            ]
        }
    },
    contentfilterblocked: {
        withHeader: true,
        columns: [{ key: "blocked", label: "Blocked" }],
        rows: {
            default: [
                { blocked: "Blocked1", },
                { blocked: "Blocked2", },
                { blocked: "Blocked3", },
                { blocked: "Blocked4", },
                { blocked: "Blocked5", },
            ]
        }
    },
    contentfilterReplace: {
        withHeader: true,
        columns: [
            { key: "replace", label: "Replace" },
            { key: "replace_with", label: "Replace_With" }
        ],
        rows: {
            default: [
                { replace: "Blocked1", replace_with: "Blocked12", },
                { replace: "Blocked2", replace_with: "Blocked23", },
                { replace: "Blocked3", replace_with: "Blocked34", },
                { replace: "Blocked4", replace_with: "Blocked45", },
                { replace: "Blocked5", replace_with: "Blocked56", },
            ]
        }
    },
    ratesheet: {
        withHeader: true,
        columns: [
            { key: "country", label: "Country" },
            { key: "telco_nw", label: "Telco Network" },
            { key: "country_code", label: "Country Code" },
            { key: "series", label: "Series" },
            { key: "final_series", label: "Final Series" },
            { key: "price", label: "Price" },
        ],
        rows: {
            default: [
                { country: "Afghanistan", telco_nw: "All networks", country_code: "93", series: "", final_series: "93", price: 1 },
                { country: "Albania", telco_nw: "Plus", country_code: "355", series: "4", final_series: "3554", price: 1.1 },
                { country: "Algeria", telco_nw: "Ooredoo Algeria", country_code: "213", series: "3", final_series: "2133", price: 0.1 },
                { country: "American Samoa", telco_nw: "Blue Sky Communications", country_code: "1684", series: "11", final_series: "168411", price: 0.2 },
                { country: "Andorra", telco_nw: "All networks", country_code: "376", series: "", final_series: "376", price: 0.4 },
                { country: "Angola", telco_nw: "Unitel Angola", country_code: "244", series: "2", final_series: "2442", price: 3 },
                { country: "Anguilla", telco_nw: "Cable & Wireless Anguilla", country_code: "1264", series: "840", final_series: "1264840", price: 5 },
                { country: "Antigua and Barbuda", telco_nw: "FLOW", country_code: "1268", series: "920", final_series: "1268920", price: 0.56 },
                { country: "Argentina", telco_nw: "All networks", country_code: "54", series: "", final_series: "54", price: 0.32 },
                { country: "Saudi Arabia", telco_nw: "All networks", country_code: "966", series: "", final_series: "966", price: 1 },
                { country: "United Arab Emirates", telco_nw: "All networks", country_code: "971", series: "", final_series: "971", price: 0.61 }
            ]
        }
    },
    networkRatesheet: {
        withHeader: true,
        columns: [
            { key: "api", label: "API" },
            { key: "device_type", label: "Device Type" },
            { key: "application", label: "Application" },
            { key: "price", label: "Price" },
        ],
        rows: {
            default: [
                {
                    api: "Number Verification: Verify",
                    device_type: "ANY",
                    application: "ANY",
                    price: 3
                },
            ]
        }
    },
    ratesheetNetwork: {
        withHeader: true,
        columns: [
            { key: "api", label: "API" },
            { key: "device_type", label: "Device Type" },
            { key: "application", label: "Application" },
            { key: "price", label: "Price" },
        ],
        rows: {
            default: [
                {
                    api: "Number Verification: Verify",
                    device_type: "ANY",
                    application: "ANY",
                    price: 3
                },
            ]
        }
    },
    ratesheetVoice: {
        withHeader: true,
        columns: [
            { key: "country", label: "Country" },
            { key: "telco_nw", label: "Telco Network" },
            { key: "country_code", label: "Country Code" },
            { key: "series", label: "Series" },
            { key: "final_series", label: "Final Series" },
            { key: "price", label: "Price" },
        ],
        rows: {
            default: [
                {
                    country: "Afghanistan",
                    telco_nw: "All networks",
                    country_code: "93",
                    series: "",
                    final_series: "412",
                    price: ""
                },
                {
                    country: "Albania",
                    telco_nw: "Plus",
                    country_code: "355",
                    series: "04",
                    final_series: "27604",
                    price: ""
                },
                {
                    country: "Algeria",
                    telco_nw: "Ooredoo Algeria",
                    country_code: "213",
                    series: "03",
                    final_series: "60303",
                    price: ""
                },
                {
                    country: "American Samoa",
                    telco_nw: "Blue Sky Communications",
                    country_code: "1684",
                    series: "11",
                    final_series: "54411",
                    price: ""
                },
                {
                    country: "Andorra",
                    telco_nw: "All networks",
                    country_code: "376",
                    series: "",
                    final_series: "213",
                    price: ""
                },
                {
                    country: "Angola",
                    telco_nw: "Unitel Angola",
                    country_code: "244",
                    series: "02",
                    final_series: "63102",
                    price: ""
                },
                {
                    country: "Anguilla",
                    telco_nw: "Cable & Wireless Anguilla",
                    country_code: "1264",
                    series: "840",
                    final_series: "365840",
                    price: ""
                },
                {
                    country: "Antigua and Barbuda",
                    telco_nw: "FLOW",
                    country_code: "1268",
                    series: "920",
                    final_series: "344920",
                    price: ""
                },
                {
                    country: "Argentina",
                    telco_nw: "All networks",
                    country_code: "54",
                    series: "",
                    final_series: "722",
                    price: ""
                },
                {
                    country: "Saudi Arabia",
                    telco_nw: "All networks",
                    country_code: "966",
                    series: "",
                    final_series: "723",
                    price: ""
                },
                {
                    country: "United Arab Emirates",
                    telco_nw: "All networks",
                    country_code: "971",
                    series: "",
                    final_series: "724",
                    price: ""
                }
            ],
            91: [
                {
                    country: "Afghanistan",
                    telco_nw: "All networks",
                    country_code: "93",
                    series: "",
                    final_series: "412",
                    price: ""
                },
                {
                    country: "Albania",
                    telco_nw: "Plus",
                    country_code: "355",
                    series: "04",
                    final_series: "27604",
                    price: ""
                },
                {
                    country: "Algeria",
                    telco_nw: "Ooredoo Algeria",
                    country_code: "213",
                    series: "03",
                    final_series: "60303",
                    price: ""
                },
                {
                    country: "American Samoa",
                    telco_nw: "Blue Sky Communications",
                    country_code: "1684",
                    series: "11",
                    final_series: "54411",
                    price: ""
                },
                {
                    country: "Andorra",
                    telco_nw: "All networks",
                    country_code: "376",
                    series: "",
                    final_series: "213",
                    price: ""
                },
                {
                    country: "Angola",
                    telco_nw: "Unitel Angola",
                    country_code: "244",
                    series: "02",
                    final_series: "63102",
                    price: ""
                },
                {
                    country: "Anguilla",
                    telco_nw: "Cable & Wireless Anguilla",
                    country_code: "1264",
                    series: "840",
                    final_series: "365840",
                    price: ""
                },
                {
                    country: "Antigua and Barbuda",
                    telco_nw: "FLOW",
                    country_code: "1268",
                    series: "920",
                    final_series: "344920",
                    price: ""
                },
                {
                    country: "Argentina",
                    telco_nw: "All networks",
                    country_code: "54",
                    series: "",
                    final_series: "722",
                    price: ""
                },
                {
                    country: "Saudi Arabia",
                    telco_nw: "All networks",
                    country_code: "966",
                    series: "",
                    final_series: "723",
                    price: ""
                },
                {
                    country: "United Arab Emirates",
                    telco_nw: "All networks",
                    country_code: "971",
                    series: "",
                    final_series: "724",
                    price: ""
                }
            ],
            212: [
                {
                    country: "Afghanistan",
                    telco_nw: "All networks",
                    country_code: "412",
                    series: "",
                    final_series: "412",
                    price: ""
                },
                {
                    country: "Albania",
                    telco_nw: "Plus",
                    country_code: "276",
                    series: "04",
                    final_series: "27604",
                    price: ""
                },
                {
                    country: "Algeria",
                    telco_nw: "Ooredoo Algeria",
                    country_code: "603",
                    series: "03",
                    final_series: "60303",
                    price: ""
                },
                {
                    country: "American Samoa",
                    telco_nw: "Blue Sky Communications",
                    country_code: "544",
                    series: "11",
                    final_series: "54411",
                    price: ""
                },
                {
                    country: "Morocco",
                    telco_nw: "All networks",
                    country_code: "212",
                    series: "",
                    final_series: "212",
                    price: ""
                },
                {
                    country: "Angola",
                    telco_nw: "Unitel Angola",
                    country_code: "631",
                    series: "02",
                    final_series: "63102",
                    price: ""
                },
                {
                    country: "Anguilla",
                    telco_nw: "Cable & Wireless Anguilla",
                    country_code: "365",
                    series: "840",
                    final_series: "365840",
                    price: ""
                },
                {
                    country: "Antigua and Barbuda",
                    telco_nw: "FLOW",
                    country_code: "344",
                    series: "920",
                    final_series: "344920",
                    price: ""
                },
                {
                    country: "Argentina",
                    telco_nw: "All networks",
                    country_code: "722",
                    series: "",
                    final_series: "722",
                    price: ""
                },
                {
                    country: "Morocco",
                    telco_nw: "All networks",
                    country_code: "212",
                    series: "",
                    final_series: "212",
                    price: ""
                },
                {
                    country: "United Arab Emirates",
                    telco_nw: "All networks",
                    country_code: "971",
                    series: "",
                    final_series: "724",
                    price: ""
                }
            ]
        }
    },
    recipient: {
        withHeader: false,
        columns: [{ key: "phone", label: "PhoneNumber" }],
        rows: {
            default: [
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
                { phone: "", },
            ]
        }
    },
    recipientEmail: {
        withHeader: false,
        columns: [{ key: "email_id", label: "Email Id" }],
        rows: {
            default: [
                { email_id: "abc@test.com" },
                { email_id: "qwerty@abc.com" },
                { email_id: "example@mail.com" },
                { email_id: "firstname@domain.com" },
                { email_id: "firstname.initial@domain.com" },
                { email_id: "firstname.secondname@domain.com" },
                { email_id: "firstname.secondname@domain.com" }
            ]
        }
    },
    coolOffPeriod: {
        withHeader: true,
        columns: [
            { key: "country", label: "Country" },
            { key: "landline", label: "Landline" },
            { key: "mobile", label: "Mobile" },
            { key: "network", label: "Network" },
            { key: "tollFree", label: "Tollfree" },
            { key: "shortCode", label: "shortcode" },
        ],
        rows: {
            default: [
                {
                    country: "IN",
                    landline: "50",
                    mobile: "45",
                    network: "",
                    tollFree: "45",
                    shortCode: ""
                },
                {
                    country: "IN",
                    landline: "45",
                    mobile: "45",
                    network: "",
                    tollFree: "300",
                    shortCode: "35"
                }
            ],
            212: [
                {
                    country: "MA",
                    landline: "50",
                    mobile: "45",
                    network: "",
                    tollFree: "45",
                    shortCode: ""
                },
                {
                    country: "MA",
                    landline: "45",
                    mobile: "45",
                    network: "",
                    tollFree: "300",
                    shortCode: "35"
                }
            ],
            233: [
                {
                    country: "AE",
                    landline: "50",
                    mobile: "45",
                    network: "",
                    tollFree: "45",
                    shortCode: ""
                },
                {
                    country: "AE",
                    landline: "45",
                    mobile: "45",
                    network: "",
                    tollFree: "300",
                    shortCode: "35"
                }
            ]
        }
    },
    contacts: {
        withHeader: false,
        columns: [{ key: "email_id", label: "Email Id" }],
        rows: {
            default: [
                { email_id: "abc@test.com" },
                { email_id: "qwerty@abc.com" },
                { email_id: "example@mail.com" },
                { email_id: "firstname@domain.com" },
                { email_id: "firstname.initial@domain.com" },
                { email_id: "firstname.secondname@domain.com" },
                { email_id: "firstname.secondname@domain.com" }
            ]
        }
    },
    contactsCsv: {
        withHeader: true,
        columns: [
            { key: "name", label: "Name" },
            { key: "email", label: "Email" },
            { key: "phone", label: "Phone" },
            { key: "address", label: "Address" },
            { key: "country_code", label: "Country Code" },
            { key: "language_preference", label: "Language Preference" },
            { key: "mobile_phone_type", label: "Mobile Phone Type" },
            { key: "mobile_phone_os_type", label: "Mobile Phone OS Type" },
            { key: "industry", label: "Industry" },
            { key: "education_level", label: "Education Level" },
            { key: "marital_status", label: "Marital Status" },
            { key: "job_title", label: "Job Title" },
            { key: "internet_connection", label: "Internet Connection" },
            { key: "online_behavior", label: "Online Behavior" },
            { key: "content_preferences", label: "Content Preferences" },
            { key: "social_media_usage", label: "Social Media Usage" },
            { key: "purchase_history", label: "Purchase History" },
            { key: "loyalty_status", label: "Loyalty Status" },
            { key: "churn_risk", label: "Churn Risk" },
            { key: "content_engagement", label: "Content Engagement" },
            { key: "user_behavior", label: "User Behavior" },
            { key: "preferred_communication_channel", label: "Preferred Communication Channel" },
            { key: "customer_feedback", label: "Customer Feedback" },
            { key: "tech_savviness", label: "Tech Savviness" },
            { key: "mobile_data_usage_behaviour", label: "Mobile Data Usage Behaviour" },
            { key: "subscription_status", label: "Subscription Status" },
            { key: "user_feedback_sentiment", label: "User Feedback Sentiment" },
            { key: "content_format_preferences", label: "Content Format Preferences" },
            { key: "interests_and_hobbies", label: "Interests and Hobbies" },
            { key: "reading_habits", label: "Reading Habits" },
            { key: "digital_banking", label: "Digital Banking" },
            { key: "music_genre_preferences", label: "Music Genre Preferences" },
            { key: "entertainment_preferences", label: "Entertainment Preferences" },
            { key: "browser", label: "Browser" },
            { key: "preferred_bank", label: "Preferred Bank" },
            { key: "subscription_type", label: "Subscription Type" },
            { key: "data_usage", label: "Data Usage" },
            { key: "roaming_status", label: "Roaming Status" },
            { key: "content_subscription", label: "Content Subscription" },
            { key: "billing_cycle_preference", label: "Billing Cycle Preference" },
            { key: "total_sms_per_month", label: "Total SMS Per Month" },
            { key: "total_voice_calls_per_month", label: "Total Voice Calls Per Month" },
            { key: "total_banking_sms_per_month", label: "Total Banking SMS Per Month" },
            {
                key: "total_customer_care_interactions_per_month",
                label: "Total Interaction with Customer Care Per Month"
            },
            {
                key: "mobile_data_usage_gb_per_month",
                label: "Mobile Data Usage (GB) per Month"
            },
            {
                key: "app_usage_installed_apps",
                label: "App Usage (Number of Apps Installed)"
            },
            { key: "income", label: "Income" }
        ],
        rows: {
            default: []
        }
    },
    placeholder: {
        withHeader: false,
        columns: [
            { key: "phone", label: "PhoneNumber" },
            { key: "val1", label: "Placeholder val one" },
            { key: "val2", label: "Placeholder val two" },
            { key: "val3", label: "Placeholder val three" },
        ],
        rows: {
            default: [
                {
                    phone: "",
                    val1: "Place_val_1",
                    val2: "Place_val_2",
                    val3: "Place_val_3"
                },
                {
                    phone: "",
                    val1: "Place_val_1",
                    val2: "Place_val_2",
                    val3: "Place_val_3"
                },
                {
                    phone: "",
                    val1: "Place_val_1",
                    val2: "Place_val_2",
                    val3: "Place_val_3"
                },
                {
                    phone: "",
                    val1: "Place_val_1",
                    val2: "Place_val_2",
                    val3: "Place_val_3"
                }
            ],
            91: [
                {
                    phone: "",
                    val1: "Place_val_1",
                    val2: "Place_val_2",
                    val3: "Place_val_3"
                },
                {
                    phone: "",
                    val1: "Place_val_1",
                    val2: "Place_val_2",
                    val3: "Place_val_3"
                },
                {
                    phone: "",
                    val1: "Place_val_1",
                    val2: "Place_val_2",
                    val3: "Place_val_3"
                },
                {
                    phone: "",
                    val1: "Place_val_1",
                    val2: "Place_val_2",
                    val3: "Place_val_3"
                }
            ]
        }
    },
    waPlaceholder: {
        withHeader: false,
        columns: [
            { key: "phone", label: "PhoneNumber" },
            { key: "val1", label: "Placeholder val one" },
            { key: "val2", label: "Placeholder val two" },
            { key: "val3", label: "Placeholder val three" },
        ],
        rows: { default: [{ phone: "", val1: "Place_val_1", val2: "Place_val_2", val3: "Place_val_3" }] }
    },
    waCarouselPlaceholder: {
        withHeader: false,
        columns: [{ key: "phone", label: "PhoneNumber" }],
        rows: { default: [{ phone: "", }] }
    },
    contacts: {
        withHeader: false,
        columns: [
            { key: "countryCode", label: "Country Code" },
            { key: "ph", label: "Phone" },
            { key: "desc", label: "Description" },
            { key: "email", label: "Email" },
            { key: "place", label: "Place" }
        ],
        rows: {
            default: [
                { countryCode: "", ph: "953819580", desc: "TempName4221", email: "email11@email.tst", place: "Bangalore" },
                { countryCode: "", ph: "944965477", desc: "TempName4222", email: "email11@email.tst", place: "Bangalore" },
                { countryCode: "", ph: "944965477", desc: "TempName4223", email: "email11@email.tst", place: "Bangalore" },
                { countryCode: "", ph: "944965477", desc: "TempName4224", email: "email11@email.tst", place: "Bangalore" },
                { countryCode: "", ph: "944965477", desc: "TempName4225", email: "email11@email.tst", place: "Bangalore" },
            ]
        }
    },
    distListEmail: {
        withHeader: false, // .txt
        columns: [{ key: "email", label: "Email" },],
        rows: {
            default: [
                { email: "abc@test.com", },
                { email: "qwerty@abc.com", },
                { email: "example@mail.com" },
                { email: "firstname@domain.com", },
                { email: "firstname.initial@domain.com ", },
                { email: "firstname.secondname@domain.com", },
                { email: "kamala.secondname@domain.com", },
            ]
        }
    },
    distList: {
        withHeader: false, // .txt
        columns: [{ key: "phone", label: "PhoneNumber" },],
        rows: {
            default: [
                { phone: "" },
                { phone: "" },
                { phone: "" },
                { phone: "" },
            ]
        }
    },
    numberTemplate: {
        withHeader: true,
        columns: [
            { key: "country", label: "Country" },
            { key: "cat", label: "Category" },
            { key: "phone", label: "PhoneNumber" },
            { key: "type", label: "Type" },
            { key: "capabilities", label: "Capabilities" },
            { key: "calling", label: "Calling" },
            { key: "otc", label: "OTC" },
            { key: "mrc", label: "MRC" },
        ],
        rows: {
            default: [
                {
                    country: "IN",
                    cat: "Normal",
                    phone: "",
                    type: "Mobile",
                    capabilities: "SMS",
                    calling: "Domestic",
                    otc: "5",
                    mrc: "5"
                },
                {
                    country: "IN",
                    cat: "Premium",
                    phone: "",
                    type: "Mobile",
                    capabilities: "SMS",
                    calling: "International",
                    otc: "10",
                    mrc: "5"
                }
            ]
        }
    },
    dltTemplate: {
        withHeader: false,
        columns: [
            { key: "L1", label: "label 1" },
            { key: "L2", label: "label 2" }
        ],
        rows: {
            default: [
                { L1: "sender_id", L2: "template_id" },
                { L1: "PAYMENT", L2: "1408172112233" },
                { L1: "EDRF", L2: "23242343433434" },
                { L1: "TEST", L2: "3453245435456" },
            ]
        }
    },
};
